import onceDetaches from 'gleam-shared/browser/onceDetaches'

export default function onceIntersects(el, rootMargin, callback) {
  const detachObserver = onceDetaches(el, onDetach)
  const intersectionObserver = new IntersectionObserver(onIntersect, { rootMargin })
  intersectionObserver.observe(el)

  return { destroy }

  function onIntersect(entries) {
    for (const { target, isIntersecting } of entries) {
      if (target === el && isIntersecting) {
        destroy()
        callback(el)
      }
    }
  }

  function onDetach() {
    destroy()
  }

  function destroy() {
    detachObserver.destroy()
    intersectionObserver.disconnect()
  }
}
